<template>
  <div>
    <!-- <template v-if="!mobileBigAndBelow">
      <h1>{{ $t('Account.AppSettings.Heading') }}</h1>
    </template> -->
    <div v-if="themeSwitcher" class="settings-holder">
      <h1>{{ $t('Account.AppSettings.Theme') }}</h1>
      <div class="options_holder">
        <div class="radio-item light" :class="{'disabled' : mobileThemeAutomaticVal}">
          <label for="light">{{$t('Account.AppSettings.Theme.Light')}}<div :class="{'selected' : selectedThemeVal === 'light' && !mobileThemeAutomaticVal}" class="radio_btn"></div></label>
          <input type="radio" id="light" value="light" :disabled="mobileThemeAutomaticVal" v-model="selectedThemeVal" @change="changeTheme('light')">
        </div>
        <div class="radio-item dark" :class="{'disabled' : mobileThemeAutomaticVal}">
          <label for="dark">{{$t('Account.AppSettings.Theme.Dark')}}<div :class="{'selected' : selectedThemeVal === 'dark' && !mobileThemeAutomaticVal}" class="radio_btn"></div></label>
          <input type="radio" id="dark" value="dark" :disabled="mobileThemeAutomaticVal" v-model="selectedThemeVal" @change="changeTheme('dark')">
        </div>
      </div>
      <div v-if="isMobileApp" class="auto">
        <!-- <label for="default">{{$t('Account.AppSettings.Theme.Automatic')}}</label>
        <input type="radio" id="default" value="default" v-model="selectedThemeVal" @change="changeTheme('default')"> -->
        <v-switch :val="mobileThemeAutomaticVal" v-model="mobileThemeAutomaticVal" :label="$t('Account.AppSettings.Theme.Automatic')" @change="changeThemeAutomatic(mobileThemeAutomaticVal)"></v-switch>
      </div>
    </div>
    <div v-if="supportedLocale.length > 1" class="settings-holder">
      <h1>{{ $t('Account.AppSettings.Language') }}</h1>
      <language-switcher class="popular expand navigation mainmenu" id="lang"></language-switcher>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import config from '@/config'
  import Screen from '@/components/mixins/Screen'
  import mobileBridge from '@/library/mobileBridge'
  import LanguageSwitcher from '@/components/layout/parts/LanguageSwitcher'
  import { localeProperties } from '@/library/locale/i18n'

  export default {
    name: 'app-settings',

    mixins: [
      Screen
    ],

    components: {
      LanguageSwitcher
    },

    data () {
      return {
      }
    },

    computed: {
      isMobileApp () {
        return window.ctsautoconf.MOBILE_LS || false
      },
      selectedThemeVal: {
        get: () => {
          return store.getters['getSelectedTheme'] || localStorage.appTheme
        },
        set: (value) => {
          store.commit('setSelectedTheme', value)
        }
      },
      mobileThemeAutomaticVal: {
        get: () => {
          return store.getters['getMobileThemeAutomatic']
        },
        set: (value) => {
          store.commit('setMobileThemeAutomatic', value)
        }
      },
      supportedLocale () {
        return localeProperties.getSupportedLocales
      },
      themeSwitcher () {
        return config.app.THEME_SWITCH || false
      }
    },

    methods: {
      changeTheme (val) {
        store.commit('setSelectedTheme', val)
        localStorage.setItem('appTheme', val)
        if (this.isMobileApp) {
          mobileBridge.bridgeSendRequest('mobileSetTheme', val)
        }
      },
      changeThemeAutomatic (val) {
        store.commit('setMobileThemeAutomatic', val)
        mobileBridge.bridgeSendRequest('mobileSetThemeAutomatic', val)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.settings-holder
  box-shadow 0 0 3px 0 rgba(0,0,0,0.25)
  background var(--navigation-bgr)
  border-radius var(--navigation-border-radius)
  padding 10px
  margin 0 0 10px 0 !important
  color var(--dialog-sports-main-nav-color) !important
  h1  
    font-size 16px
.auto
  padding 0 0 10px 0
  display: flex
  justify-content: space-between
  >>>.v-messages
    display none
  >>>.v-label
   color var(--dialog-sports-main-nav-color) !important
   font-family 'Roboto Condensed'
  >>>.v-input__control
    width 100%
    .v-input__slot
      margin-bottom 0
      justify-content: space-between
      flex-direction: row-reverse
    .v-input--switch__track
      height 27px
      top: calc(50% - 13px)
      width 46px
      left -3px
      border-radius 15px
      color var(--app-settings-switch-bgr) !important
      opacity 1
    .v-input--selection-controls__ripple
      width 46px
  >>>.v-input--switch 
      .v-input--switch__thumb.theme--light.accent--text
        color #fff !important
      &.v-input--is-dirty 
        .v-input--switch__thumb
          transform: translate(25px) !important
        .v-input--switch__track
          left 2px
          color var(--app-settings-switch-selected-bgr) !important
        .accent--text
          color var(--app-settings-switch-selected-bgr) !important
.options_holder
  display flex
  justify-content: space-around
  align-items: center
  flex-direction: row
  .radio-item
    padding-top 15px
    text-align: center
    height 64px
    border-radius 5px
    width 100%
    margin-right 5px
    border var(--app-settings-option-border)
    &:last-child
      margin-right: 0
    &.disabled
      opacity 0.5
    input[type="radio"]
      display none
    label
      height 64px
      width 100%
      display block
      font-family 'Roboto Condensed'
    .radio_btn
      background var(--app-settings-radio-btn)
      width 17px
      height 17px
      margin auto
      &.selected
        background var(--app-settings-radio-btn-selected)
    &.dark
      background var(--app-settings-option-dark-bgr)
      color var(--app-settings-option-dark-color)
    &.light
      background var(--app-settings-option-light-bgr)
      color var(--app-settings-option-light-color)

    

</style>



// WEBPACK FOOTER //
// src/components/common/AppSettings.vue